/**
 * Strips HTML tags from a string
 * @param html - String that may contain HTML tags
 * @returns Plain text string with HTML tags removed
 */

export function stripHtml (html: string): string {
    if (!html) {
        return '';
    }

    // Create a temporary div element to use the browser's HTML parser
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
}
